import { render, staticRenderFns } from "./add-income.vue?vue&type=template&id=545ccba2&scoped=true&"
import script from "./add-income.vue?vue&type=script&lang=js&"
export * from "./add-income.vue?vue&type=script&lang=js&"
import style0 from "./add-income.vue?vue&type=style&index=0&id=545ccba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ccba2",
  null
  
)

export default component.exports